import { ReactElement } from 'react';

import { MedicalField } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { Autosuggest } from '@dreryk/react-components';
import { BindingCreator } from '@dreryk/react-common';

import { dischargeSummaryTranslationKeys } from '../../../translations';

import {
   medicalFieldItemRenderer,
   medicalFieldKeyPropertyExtractor,
   medicalFieldLabelExtractor,
   medicalFieldSearchCreator,
} from './MedicalFieldAutosuggest.utils';

type MedicalFieldAutosuggestFormBeanPart = {
   medicalField: MedicalField | null;
};

type MedicalFieldAutosuggestProps = {
   register: BindingCreator<MedicalFieldAutosuggestFormBeanPart, 'medicalField'>;
};

export const MedicalFieldAutosuggest = (props: MedicalFieldAutosuggestProps): ReactElement => {
   return (
      <Autosuggest<MedicalField>
         testId={'selectMedicalField'}
         itemRenderer={medicalFieldItemRenderer}
         searchCreator={medicalFieldSearchCreator}
         keyProperty={medicalFieldKeyPropertyExtractor}
         labelExtractor={medicalFieldLabelExtractor}
         controller={props.register('medicalField', { required: true })}
         placeholder={dischargeSummaryTranslationKeys.searchMedicalFieldByCodeOrName}
         label={dischargeSummaryTranslationKeys.medicalField}
      />
   );
};
